import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type CertificateSettingsFragment = { certificateTemplateId: string, allowLinkedinProfile: boolean, allowSocialSharing: boolean, allowDownload: boolean, minPercentage?: number | null };


export type CertificateSettingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CertificateSettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment CertificateSettings on CertificateSettings {
  certificateTemplateId
  allowLinkedinProfile
  allowSocialSharing
  allowDownload
  minPercentage
}
    `;